/* eslint-disable promise/catch-or-return */
import $ from 'jquery';
import axios from 'axios';
import { isNil } from 'lodash';
import moment from 'moment';
import { extendMoment } from 'moment-range';
import { x, highLightSelected, addUrlPart, ucWords } from '../_helpers';
import {
  tournamentsListHook,
  tournamentsListDataHook,
  updateTournamentsListEvent,
  dataLoadStartEvent,
  dataLoadEndEvent,
  loaderClass,
  tournamentslistClass,
  tournamentslistfilterClass,
  activeClassName,
  hiddenClassName,
  tournamentsErrorMessageClass,
  tournamentsMonth,
  calendarMonthHook,
  tournamentslistCardStatusClass,
  tournamentslistCardDatesClass,
  tournamentslistCardDatesItemClass,
  tournamentslistCardTitleClass,
  compareDateFormat,
  tournamentslistStatusCancelled,
  tournamentslistCardStatusCancelledClass,
  tournamentslistStatusLiveClassName,
  tournamentslistLiveScrollItemHook,
  tournamentslistLiveScrollItemClass,
  animationSpeed,
  mainHeaderClass,
  tournamentslistStatus,
  hiddenClass
} from '../_helpers/constants';

import TournamentCalendar from './tournament-calendar';

export default class TournamentsList {
  constructor(el, opts) {
    this.moment = extendMoment(moment);
    this.cancelledSeed = tournamentslistStatusCancelled;
    this.tournamentCalendar = new TournamentCalendar();
    this.baseUrl = location.href;
    this.lists = x(tournamentsListHook);
    this.element = el;

    this.dataContainer = x(tournamentsListDataHook)[0];

    this.filterItems = [];
    this.listItems = [];
    this.errorMessage = $(tournamentsErrorMessageClass);
    this.liveItemsCount = 0;
    this.translations = opts.translations;
    this.setList();
  }

  addClickEvent() {
    this.filterItems = $(tournamentslistfilterClass);
    const _self = this;
    this.filterItems.each(function (index) {
      $(this).on('click', function (event) {
        const seed = _self.getSeed(event);
        const active = event.target.classList.contains('active');
        _self.filter(seed, index, active);
      });
    });
  }

  setStartingFilter() {
    highLightSelected(this.filterItems, 0, activeClassName);
  }

  getSeed(event = null, element = null) {
    if (event !== null) {
      return event.target.attributes['data-seed'].value;
    }
    if (element !== null) {
      return element.getAttribute('data-seed');
    }
  }

  filter(value, index, reset = false) {
    if (reset) {
      this.resetList();
      this.resetFilters();
      return;
    }

    this.loadData(value);

    highLightSelected(this.filterItems, index, activeClassName);
  }

  loadData(value) {
    const month = $(calendarMonthHook).attr(tournamentsMonth);

    let newUrl = addUrlPart(`${this.baseUrl}library/`, `${month}/`);

    if (!isNil(value) && value !== '') {
      newUrl = addUrlPart(newUrl, `${value}/`);
    }

    this.getData(newUrl);
  }

  getData(url) {
    window.dispatchEvent(new CustomEvent(dataLoadStartEvent));
    axios.get(url).then((resp) => {
      const response = {
        detail: { data: resp.data },
      };

      this.updateList(response, false);

      window.dispatchEvent(new CustomEvent(dataLoadEndEvent));
      return resp.data;
    });
  }

  resetList() {
    $(tournamentslistClass).removeClass(hiddenClassName);
  }

  resetFilters() {
    this.filterItems.removeClass(activeClassName);
  }

  updateList(res, resetFilters = true) {
    this.liveItemsCount = 0;
    const data = res.detail.data;
    this.dataContainer.innerHTML = data;
    this.setList();
    if (resetFilters) {
      this.setStartingFilter();
    }
    this.checkAddedItems();
    this.tournamentCalendar.init();
  }

  setList() {
    const _self = this;
    this.listItems = $(tournamentslistClass);
    this.setHeadersItems();
    window.setTimeout(() => {
      _self.scrollToItem();
    }, 1000);
  }
  setHeadersItems() {
    const items = this.listItems;
    const _self = this;
    items.each(function () {
      const header = $(this).find(tournamentslistCardStatusClass);
      const title = $(this).find(tournamentslistCardTitleClass);
      if (_self.isCancelled(title)) {
        _self.setHeader(header, _self.translations.cancelledLabel);
        _self.removeCancelledFromTitle(title);
        $(this).find(tournamentslistCardStatusCancelledClass).removeClass(hiddenClassName);
        $(this).attr("data-status", tournamentslistStatus.cancelled);
      } else {
        const dates = $(this).find(tournamentslistCardDatesClass);
        const startDate = _self.moment(dates.data('start-date'));
        const endDate = _self.moment(dates.data('end-date'));
        const today = _self.moment(_self.moment(new Date()).format(compareDateFormat));

        if (_self.isLive(startDate, endDate, today)) {
          _self.liveItemsCount++;
          _self.setHeader(
            header,
            _self.translations.liveLabel,
            _self.liveItemsCount,
            tournamentslistStatusLiveClassName
          );
          _self.setDaysLabel(startDate, endDate, today, dates);
          $(this).attr("data-status", tournamentslistStatus.live);
        } else if (_self.isNotStarted(startDate, today)) {
          _self.setHeader(header, _self.translations.notStartedLabel);
          $(this).attr("data-status", tournamentslistStatus.notStarted);
        } else if (_self.isFinished(endDate, today)) {
          _self.setHeader(header, _self.translations.resultLabel);
          $(this).attr("data-status", tournamentslistStatus.result);
        }
      }
    });
  }

  setHeader(header, text, liveItemsCount, additionalClass = null) {
    $(header).html(text);
    if (liveItemsCount === 1 && $(header).parents(".tc-tournaments").hasClass(tournamentslistLiveScrollItemClass)) {
      $(header).attr('id', tournamentslistLiveScrollItemHook);
    }
    if (!isNil(additionalClass)) {
      $(header).addClass(additionalClass);
    }
  }

  setDaysLabel(startDate, endDate, clientDate, dates) {
    const _self = this;
    const datesContainer = $(dates).find(tournamentslistCardDatesItemClass);
    const strongArray = $(datesContainer).find('strong');
    const spanArray = $(datesContainer).find('span');

    const isCountryFormat = dates.data('country-format').toLowerCase() === "true";
    let days = dates.data('total-days');
    let day = dates.data('current-day');

    if (!isCountryFormat || !(days && day && days > 0 && day > 0))
    {
      days = endDate.diff(startDate, 'days') + 1;
      day = clientDate.diff(startDate, 'days') + 1;
    }

    $(strongArray[0]).html(`${_self.translations.dayLabel} ${day}`);
    $(spanArray[0]).html('');
    $(spanArray[1]).html(`${_self.translations.ofLabel}`);
    $(spanArray[2]).html('');
    $(strongArray[1]).html(days);
  }

  removeCancelledFromTitle(title) {
    const seed = ucWords(this.cancelledSeed);

    const formattedTitle = title
      .html()
      .replace(`(${seed})`, '')
      .replace(seed, '')
      .replace(`(${this.cancelledSeed})`, '')
      .replace(this.cancelledSeed, '');
    title.html(formattedTitle);
  }

  isCancelled(title) {
    return (
      title.html().toLowerCase().indexOf(this.cancelledSeed) > -1 ||
      title.html().toLowerCase().indexOf(`(${this.cancelledSeed})`) > -1
    );
  }

  isLive(startDate, endDate, clientDate) {
    const range = this.moment().range(startDate, endDate);
    return range.contains(clientDate);
  }

  isNotStarted(startDate, clientDate) {
    return this.moment(clientDate).isBefore(startDate);
  }

  isFinished(endDate, clientDate) {
    return this.moment(clientDate).isAfter(endDate);
  }

  scrollToItem() {
    const element = $(`#${tournamentslistLiveScrollItemHook}`);

    if (isNil(element) || element.length === 0) {
      return;
    }

    const offsetTop =
      element[0].offsetParent.offsetTop -
      $(mainHeaderClass).outerHeight() -
      parseInt($(mainHeaderClass).css('margin-bottom').replace('px', ''), 10) -
      50;

    $('html, body').animate(
      {
        scrollTop: offsetTop,
      },
      animationSpeed
    );
  }

  checkAddedItems() {
    return this.listItems.length === 0
      ? this.errorMessage.removeClass(hiddenClassName)
      : this.errorMessage.addClass(hiddenClassName);
  }

  loader(show = true) {
    return show
      ? $(loaderClass).removeClass(hiddenClassName)
      : $(loaderClass).addClass(hiddenClassName);
  }

  init() {
    if (this.lists) {
      window.addEventListener(dataLoadStartEvent, () => {
        this.loader();
      });
      window.addEventListener(dataLoadEndEvent, () => {
        this.loader(false);
      });
      window.addEventListener(updateTournamentsListEvent, (e) => {
        this.updateList(e);
      });

      this.addClickEvent(this.element);

      this.setStartingFilter();
    }
  }
}
